'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logout = exports.login = exports.REFRESHING_TOKEN_FAILURE = exports.REFRESHING_TOKEN_SUCCESS = exports.REFRESHING_TOKEN_STARTED = exports.LOGOUT_FAILURE = exports.LOGOUT_SUCCESS = exports.LOGOUT_STARTED = exports.LOGIN_FAILURE = exports.LOGIN_SUCCESS = exports.LOGIN_STARTED = exports.UPDATE_IAM_CONFIG = undefined;
exports.refreshExpiredToken = refreshExpiredToken;

var _openIdConnect = require('./openIdConnect');

var _config = require('./util/config');

var UPDATE_IAM_CONFIG = exports.UPDATE_IAM_CONFIG = 'iam/auth/UPDATE_IAM_CONFIG';

var LOGIN_STARTED = exports.LOGIN_STARTED = 'iam/auth/LOGIN_STARTED';
var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'iam/auth/LOGIN_SUCCESS';
var LOGIN_FAILURE = exports.LOGIN_FAILURE = 'iam/auth/LOGIN_FAILURE';

var LOGOUT_STARTED = exports.LOGOUT_STARTED = 'iam/auth/LOGOUT_STARTED';
var LOGOUT_SUCCESS = exports.LOGOUT_SUCCESS = 'iam/auth/LOGOUT_SUCCESS';
var LOGOUT_FAILURE = exports.LOGOUT_FAILURE = 'iam/auth/LOGOUT_FAILURE';

var REFRESHING_TOKEN_STARTED = exports.REFRESHING_TOKEN_STARTED = 'iam/auth/REFRESHING_TOKEN_STARTED';
var REFRESHING_TOKEN_SUCCESS = exports.REFRESHING_TOKEN_SUCCESS = 'iam/auth/REFRESHING_TOKEN_SUCCESS';
var REFRESHING_TOKEN_FAILURE = exports.REFRESHING_TOKEN_FAILURE = 'iam/auth/REFRESHING_TOKEN_FAILURE';

var updateIamConfig = function updateIamConfig(iamConfig) {
  return {
    type: UPDATE_IAM_CONFIG,
    clientId: iamConfig.client_id,
    iamConfig: iamConfig
  };
};

var loginStarted = function loginStarted(clientId) {
  return {
    type: LOGIN_STARTED,
    clientId: clientId
  };
};

var loginSuccess = function loginSuccess(token, idToken, clientId) {
  return {
    type: LOGIN_SUCCESS,
    clientId: clientId,
    token: token,
    idToken: idToken
  };
};

var loginFailure = function loginFailure(error, clientId) {
  return {
    type: LOGIN_FAILURE,
    clientId: clientId,
    error: error
  };
};

var logoutStarted = function logoutStarted(clientId) {
  return {
    type: LOGOUT_STARTED,
    clientId: clientId
  };
};

var logoutSuccess = function logoutSuccess(clientId) {
  return {
    type: LOGOUT_SUCCESS,
    clientId: clientId
  };
};

var logoutFailure = function logoutFailure(error, clientId) {
  return {
    type: LOGOUT_FAILURE,
    error: error,
    clientId: clientId
  };
};

var refreshingToken = function refreshingToken(refreshTokenPromise, clientId) {
  return {
    type: REFRESHING_TOKEN_STARTED,
    refreshTokenPromise: refreshTokenPromise,
    clientId: clientId
  };
};

var refreshingTokenSuccess = function refreshingTokenSuccess(token, idToken, clientId) {
  return {
    type: REFRESHING_TOKEN_SUCCESS,
    token: token,
    idToken: idToken,
    clientId: clientId
  };
};

var refreshingTokenFailure = function refreshingTokenFailure(error, clientId) {
  return {
    type: REFRESHING_TOKEN_FAILURE,
    error: error,
    clientId: clientId
  };
};

var dispatchLoginStatus = function dispatchLoginStatus(loginResult, clientId, dispatch) {
  if (loginResult.type === _openIdConnect.LOGIN_CHECK_SUCCESS) {
    return dispatch(loginSuccess(loginResult.token, loginResult.idToken, clientId));
  } else if (loginResult.type !== _openIdConnect.LOGIN_CHECK_FORWARDING_STARTED) {
    return dispatch(loginFailure(loginResult.error, clientId));
  }

  return null;
};

var login = exports.login = function login(config) {
  var autoRedirectToIdp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (dispatch) {
    var mergedConfig = (0, _config.mergeWithDefaults)(config);
    dispatch(loginStarted(mergedConfig.client_id));
    dispatch(updateIamConfig(mergedConfig, mergedConfig.client_id));

    var loginResult = (0, _openIdConnect.authorize)(mergedConfig, mergedConfig.client_id, autoRedirectToIdp);

    if (typeof loginResult.then !== 'function') {
      return dispatchLoginStatus(loginResult, mergedConfig.client_id, dispatch);
    }

    return loginResult.then(function (result) {
      return dispatchLoginStatus(result, mergedConfig.client_id, dispatch);
    });
  };
};

var dispatchRefreshStatus = function dispatchRefreshStatus(refreshResult, clientId, dispatch) {
  if (refreshResult.type === _openIdConnect.LOGIN_CHECK_SUCCESS) {
    return dispatch(refreshingTokenSuccess(refreshResult.token, refreshResult.idToken, clientId));
  } else if (refreshResult.type !== _openIdConnect.LOGIN_CHECK_FORWARDING_STARTED) {
    return dispatch(refreshingTokenFailure(refreshResult.error, clientId));
  }

  return refreshResult;
};

// This is special --> dispatch will be provided by auth middleware
function refreshExpiredToken(config, dispatch) {
  var mergedConfig = (0, _config.mergeWithDefaults)(config);
  dispatch(updateIamConfig(mergedConfig, mergedConfig.client_id));

  var refreshResult = (0, _openIdConnect.refreshToken)(mergedConfig, mergedConfig.client_id);

  if (typeof refreshResult.then !== 'function') {
    return dispatchRefreshStatus(refreshResult, mergedConfig.client_id, dispatch);
  }

  dispatch(refreshingToken(refreshResult, mergedConfig.client_id));
  refreshResult.then(function (result) {
    return dispatchRefreshStatus(result, mergedConfig.client_id, dispatch);
  });

  return refreshResult;
}

var dispatchLogoutStatus = function dispatchLogoutStatus(logoutResult, clientId, config, startReLogin, dispatch) {
  if (logoutResult.type === _openIdConnect.LOGOUT_PROCESS_SUCCESS) {
    dispatch(logoutSuccess(clientId));
    if (startReLogin) {
      return dispatch(login(config, true));
    }
  } else if (!logoutResult.type !== _openIdConnect.LOGOUT_PROCESS_FORWARDING_STARTED) {
    return dispatch(logoutFailure(logoutResult.error, clientId));
  }

  return null;
};

var logout = exports.logout = function logout(config) {
  var startReLogin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    var mergedConfig = (0, _config.mergeWithDefaults)(config);
    dispatch(logoutStarted(mergedConfig.client_id));
    dispatch(updateIamConfig(mergedConfig, mergedConfig.client_id));

    var logoutResult = (0, _openIdConnect.initializeLogoutProcess)(mergedConfig, mergedConfig.client_id);

    if (typeof logoutResult.then !== 'function') {
      return dispatchLogoutStatus(logoutResult, mergedConfig.client_id, mergedConfig, startReLogin, dispatch);
    }

    return logoutResult.then(function (result) {
      return dispatchLogoutStatus(result, mergedConfig.client_id, mergedConfig, startReLogin, dispatch);
    });
  };
};